import React from 'react';
import { GlobeIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-surface px-5 py-14 sm:px-8" data-id="element-100" data-mp="3gfsmscqd8umz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-101" data-mp="3ghc5e9zhvhrx">
        <p className="text-2xl font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-102" data-mp="32ovw4rg02nik">
          🏋️ Nucleo Fit™
        </p>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-neutral-400" data-id="element-103" data-mp="36pza18ehm9h5">
          El sistema de entrenamiento N°1 para atletas de calistenia en
          Argentina. Porque progresar en calistenia no debería costarte meses de
          estancamiento y frustración.
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm" data-id="element-104" data-mp="3ldkdx4j6scq4">
          <li data-id="element-105" data-mp="3qc3yp1m1nigw">
            <a href="mailto:soporte.nucleofit@gmail.com" className="inline-flex items-center gap-2 text-neutral-300 transition-colors hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-106" data-mp="3qblwzpgm4c1l">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="3l8qwo57filrz" />
              soporte.nucleofit@gmail.com
            </a>
          </li>
          <li data-id="element-108" data-mp="3gca859wbi5ed">
            <a href="https://www.nucleofit.shop" className="inline-flex items-center gap-2 text-neutral-300 transition-colors hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-109" data-mp="3gcjw6rxsy2hf">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-110" data-mp="81yvyfozns2e" />
              www.nucleofit.shop
            </a>
          </li>
        </ul>

        <p className="mt-8 border-t border-line pt-8 text-xs leading-relaxed text-neutral-600" data-id="element-111" data-mp="31uoff6267ob">
          © Nucleo Fit™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
        <p className="mt-4 text-xs italic text-neutral-500" data-id="element-112" data-mp="qsqf28ys2wtz">
          “El próximo entrenamiento puede ser diferente.”
        </p>
      </div>
    </footer>;
}